/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'middle_arrow': {
    width: 10,
    height: 15,
    viewBox: '0 0 10 15',
    data: '<path pid="0" d="M1 1l7 6.5L1 14" _stroke="#0078D2" stroke-width="2"/>'
  }
})
